module.exports = __webpack_public_path__ + "images/category_lp/watch/person_52a6660f530f2aa32187c0f3a29e3ee2.png";